import {
  Autocomplete,
  Backdrop,
  BackdropRoot,
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  ThemeProvider,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import React, { useRef } from "react";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import StarsIcon from "@mui/icons-material/Stars";
import { useEffect, useState, useMemo } from "react";
import CancelIcon from "@mui/icons-material/Cancel";
import { Link, useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

import { createTheme } from "@mui/material/styles";

import { toast } from "react-toastify";
import axios from "axios";
import { ToastContainer } from "react-toastify/dist";
import Loader from "../../../../components/Loader";
import CenterFocusStrongIcon from "@mui/icons-material/CenterFocusStrong";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

// tablle imports

import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";

import { useDispatch, useSelector } from "react-redux";

import dayjs from "dayjs";

import moment from "moment";
import { common_axios } from "../../../../App";
import CheckBox from "../../UserManagement/Tables/CheckBox";
import DashboradTable from "../../Dashboard/DashboradTable";
import ThumbDownAltIcon from "@mui/icons-material/ThumbDownAlt";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { dateFormatter } from "../../../../helper/helper";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import Swal from "sweetalert2";
// import CheckBox from "./CheckBox";

export default function AprovalAttendance() {
  const [open, setOpen] = useState(false);

  const [location, setLocation] = React.useState({
    leaveType: "",
    reason: "",
    showlastdiv: false,
  });
  const [data, setData] = useState([]);
  const [showdata, setshowData] = useState(false);
  const [value, setValue] = React.useState(dayjs(new Date()));
  const [valuee, setValuee] = React.useState();
  const [ee1, setee1] = useState({
    dateform: null,
  });
  const [valueofLeavs, setvalueofLeavs] = useState("");

  const [datee, setdatee] = useState({
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
  });

  const [daysDiff, setdaysDiff] = useState(1);
  var [date, setDate] = useState(new Date());

  const [stateofButtons, setstateofButtons] = useState({
    approval: false,
    reject: false,
  });
  const [response, setresponse] = useState("");

  useEffect(() => {
    var timer = setInterval(() => setDate(new Date()), 1000);
    return function cleanup() {
      clearInterval(timer);
    };
  });
  const mindate = moment(new Date()).subtract(2, "days");

  const handleChange = (newValue) => {
    setValue(newValue);
  };
  const handleChangee = (newValue) => {
    setValuee(newValue);
  };
  var date = moment(valuee?.$d);
  var now = moment(value?.$d);
  var duration = moment.duration(date.diff(now));
  var noofDays = duration.asDays();

  var stat = moment().format("MMMM Do YYYY, h:mm:ss a");

  useEffect(() => {
    setdaysDiff(Math.ceil(noofDays) + 1);
  }, [value?.$d, valuee?.$d]);

  const usermodal = JSON.parse(localStorage.getItem("usermodal"))?.userGroups;

  const columns = useMemo(
    () => [
      {
        Header: "S.no",

        accessor: "S.no",
        Cell: (cell) => {
          return <>{cell.row.index + 1}</>;
        },
      },

      {
        Header: "Date",

        accessor: "date",
        Cell: (cell) => {
          return (
            <>
              {moment(cell.row.original.date, "YYYY-MM-DD").format(
                "DD-MMM-YYYY"
              )}
            </>
          );
        },
      },

      {
        Header: "Employee Name",

        accessor: "employeename",
        Cell: (cell) => (
          <>
            {cell.row.original.firstName && cell.row.original.lastName ? (
              <>
                <span>
                  {cell.row.original.firstName}
                  &nbsp;
                  {cell.row.original.lastName}
                </span>
              </>
            ) : (
              <>
                <span>N/A</span>
              </>
            )}
          </>
        ),
      },
      {
        Header: "Reason",

        accessor: "reason",
      },

      {
        Header: "Leave-Type",

        accessor: "status",
        Cell: (cell) => (
          <>
            {cell.row.original.status == 2 ? (
              <>
                <span>Casual Leave</span>
              </>
            ) : cell.row.original.status == 3 ? (
              <>
                <span>Optional off</span>
              </>
            ) : cell.row.original.status == 4 ? (
              <>
                <span>Saturday Off</span>
              </>
            ) : cell.row.original.status == 5 ? (
              <>
                <span>Short Leave</span>
              </>
            ) : cell.row.original.status == 6 ? (
              <>
                <span>Work from home</span>
              </>
            ) : null}
          </>
        ),
      },

      //   {
      //     Header: "Action",
      //     Footer: "Action",
      //     accessor: "action",
      //     Cell: (cell) => {
      //       return (
      //         <div className="dropdown">
      //           <button
      //             className="btn color_1 dropdown-toggle"
      //             type="button"
      //             id="dropdownMenuButton1"
      //             data-bs-toggle="dropdown"
      //             aria-expanded="false"
      //           >
      //             <i className="material-icons opacity-10 size">person</i>
      //           </button>
      //           <ul
      //             className="dropdown-menu"
      //             aria-labelledby="dropdownMenuButton1"
      //           >
      //             <li>
      //               <a
      //                 className="dropdown-item"
      //                 onClick={() => {
      //                   editEmployeeModal(cell);
      //                 }}
      //               >
      //                 <EditIcon sx={{ fontSize: "17px", marginRight: "10px" }} />
      //                 View Details
      //               </a>
      //             </li>
      //             <li>
      //               <a
      //                 className="dropdown-item"
      //                 onClick={() => {
      //                   ViewAttendance(cell);
      //                   viewAttendanceEmployeeModal(cell);
      //                 }}
      //               >
      //                 <AutorenewIcon
      //                   sx={{ fontSize: "17px", marginRight: "10px" }}
      //                 />
      //                 View Attendance
      //               </a>
      //             </li>
      //           </ul>
      //         </div>
      //       );
      //     },

      //     disableFilters: true,
      //   },
    ],
    []
  );

  const approvval = useRef(null);
  const rejecytion = useRef(null);

  const approvalModal = async () => {
    await approvval.current.click();
  };
  const rejecytionModal = async () => {
    await rejecytion.current.click();
  };

  const markAttendacneref = useRef(null);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
      // initialState: { pageIndex: 1 },
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => {
        return [
          {
            id: "selection",
            Header: ({ getToggleAllRowsSelectedProps }) => (
              <CheckBox {...getToggleAllRowsSelectedProps()} />
            ),
            Cell: ({ row }) => (
              <CheckBox {...row.getToggleRowSelectedProps()} />
            ),
          },
          ...columns,
        ];
      });
    }
  );
  const { globalFilter, pageIndex, pageSize } = state;
  const deletUser = async () => {
    console.log({ selectedFlatRows });
  };

  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: {
            color: "red",
          },
        },
      },
    },
    palette: {
      primary: {
        main: "#FFA500", //this overide blue color
        // light: "#fff", //overides light blue
        // dark: "#fff", //overides dark blue color
      },
    },
  });

  const getButtonAdd = useSelector(
    (datar) => datar?.EmployeeSlice?.employeebutton
  );

  const pendingLeaves = async () => {
    try {
      setOpen(true);
      const res = await common_axios.post(
        `attendance/allPendingLeaves?id=${localStorage.getItem("UserId")}`
      );

      if (res.data.statusDescriptions.statusCode == 200) {
        setOpen(false);

        setData(res.data.attendanceEntity);

        // x.toLocaleDateString()
      } else {
        setOpen(false);
        setresponse(res.data.statusDescriptions.statusDescription);
        // await toast.error(res.data.statusDescriptions.statusDescription, {
        //   theme: "colored",
        // });
      }
    } catch (error) {
      console.log(error);
      setOpen(false);
      // await toast.error("Something Went Wrong !! Please check your network ", {
      //   theme: "colored",
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something Went Wrong !! Please check your network ",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  useEffect(() => {
    pendingLeaves();
  }, []);

  const usergroup = JSON.parse(localStorage.getItem("usermodal"))?.userGroups;

  const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);

  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 1000);

  const modalMarkClose = useRef(null);

  const ApprovalAPi = async () => {
    try {
      setOpen(true);
      if (stateofButtons?.approval == true) {
        let attendanceRequests = [];

        for (let i = 0; i < selectedFlatRows.length; i++) {
          let element = selectedFlatRows[i];

          element.original.isApproved = 1;
          element.original.fromDate = moment(
            element.original.date,
            "YYYY-MM-DD"
          ).format("YYYY-MM-DD");
          element.original.numberOfDays = 1;
          attendanceRequests.push(element.original);
        }

        const res = await common_axios.post(
          `attendance/bulkApprovalRejection`,
          {
            approvalRejectionRequests: attendanceRequests,
          }
        );

        if (res.data.statusDescriptions.statusCode == 200) {
          setOpen(false);
          await markAttendacneref.current.click();

          await pendingLeaves();
          // await toast.success(res.data.statusDescriptions.statusDescription, {
          //   theme: "colored",
          // });
          Swal.fire({
            icon: "success",
            // title: "Oops...",
            text: res.data.statusDescriptions.statusDescription,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
          // x.toLocaleDateString()
        } else {
          setOpen(false);
          await markAttendacneref.current.click();
          // await toast.error(res.data.statusDescriptions.statusDescription, {
          //   theme: "colored",
          // });
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescriptions.statusDescription,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      } else if (stateofButtons?.reject == true) {
        let attendanceRequests = [];

        for (let i = 0; i < selectedFlatRows.length; i++) {
          let element = selectedFlatRows[i];

          element.original.isApproved = 2;
          element.original.numberOfDays = 1;
          element.original.fromDate = moment(
            element.original.date,
            "YYYY-MM-DD"
          ).format("YYYY-MM-DD");
          attendanceRequests.push(element.original);
        }

        const res = await common_axios.post(
          `attendance/bulkApprovalRejection`,
          {
            approvalRejectionRequests: attendanceRequests,
          }
        );

        if (res.data.statusDescriptions.statusCode == 200) {
          setOpen(false);
          await markAttendacneref.current.click();
          await pendingLeaves();
          // await setData([]);
          // await toast.success(res.data.statusDescriptions.statusDescription, {
          //   theme: "colored",
          // });
          Swal.fire({
            icon: "success",
            // title: "Oops...",
            text: res.data.statusDescriptions.statusDescription,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
          // x.toLocaleDateString()
        } else {
          setOpen(false);
          await markAttendacneref.current.click();
          // await toast.error(res.data.statusDescriptions.statusDescription, {
          //   theme: "colored",
          // });
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescriptions.statusDescription,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      }
    } catch (error) {
      console.log(error);
      setOpen(false);
      await markAttendacneref.current.click();
      // await toast.error("Something Went Wrong !! Please check your network ", {
      //   theme: "colored",
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something Went Wrong !! Please check your network ",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  return (
    <>
      {" "}
      <section class="form_card mt-5">
        <ToastContainer autoClose={5000} />

        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
        >
          <Loader />
        </Backdrop>

        <>
          <button
            ref={approvval}
            type="button"
            className="btn btn-primary d-none"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop9"
          >
            Launch static backdrop modal
          </button>

          <div
            className="modal mark fade"
            id="staticBackdrop9"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabindex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="staticBackdropLabel">
                    Leave Approval?
                  </h5>
                  <button
                    ref={markAttendacneref}
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => {
                      setstateofButtons({
                        approval: false,
                        reject: false,
                      });
                    }}
                  ></button>
                </div>
                <ThemeProvider theme={theme}>
                  <div className="modal-body">
                    <h5> Are you sure to approve ?</h5>
                  </div>
                </ThemeProvider>
                <div className="modal-footer d-flex justify-content-between align-items-center">
                  <Button
                    data-bs-dismiss="modal"
                    sx={{ marginLeft: "10px", background: "#4C4234" }}
                    variant="contained"
                    endIcon={<CancelIcon />}
                    onClick={() => {
                      setstateofButtons({
                        approval: false,
                        reject: false,
                      });
                    }}
                  >
                    No
                  </Button>
                  <Button
                    data-bs-dismiss="modal"
                    sx={{ marginLeft: "10px", background: "#F96902" }}
                    variant="contained"
                    endIcon={<CheckCircleIcon />}
                    onClick={() => {
                      ApprovalAPi();
                    }}
                  >
                    Yes
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <button
            ref={rejecytion}
            type="button"
            className="btn btn-primary d-none"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop19"
          >
            Launch static backdrop modal
          </button>

          <div
            className="modal mark fade"
            id="staticBackdrop19"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabindex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="staticBackdropLabel">
                    Leave Rejection?
                  </h5>
                  <button
                    ref={markAttendacneref}
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => {
                      setstateofButtons({
                        approval: false,
                        reject: false,
                      });
                    }}
                  ></button>
                </div>
                <ThemeProvider theme={theme}>
                  <div className="modal-body">
                    <h5> Are you sure to reject ?</h5>
                  </div>
                </ThemeProvider>
                <div className="modal-footer d-flex justify-content-between align-items-center">
                  <Button
                    data-bs-dismiss="modal"
                    sx={{ marginLeft: "10px", background: "#4C4234" }}
                    variant="contained"
                    endIcon={<CancelIcon />}
                    onClick={() => {
                      setstateofButtons({
                        approval: false,
                        reject: false,
                      });
                    }}
                  >
                    No
                  </Button>
                  <Button
                    data-bs-dismiss="modal"
                    sx={{ marginLeft: "10px", background: "#F96902" }}
                    variant="contained"
                    endIcon={<CheckCircleIcon />}
                    onClick={() => {
                      ApprovalAPi();
                    }}
                  >
                    Yes
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </>

        <div class="container-fluid" id="cont_fluid">
          <div class="card d-block" id="new_store_entry">
            <div class="card-header p-3 position-relative border-0 bg-white">
              <div class="ttl_bx position-absolute d-flex mt_n4">
                {/* <i class="fas fa-user d-block m-auto"></i> */}
                <PendingActionsIcon
                  class="fas fa-user d-block m-auto"
                  style={{ color: "white" }}
                />
              </div>
              <div class="d-flex justify-content-between title_8 mx-7">
                <p>Pending Requests</p>
                {/* <p class="text-sm mb-0 text-capitalize fw-bold">
                    Fields mark with!!
                    <span class="text-danger fw-bold">*</span> are mandatory.
                  </p> */}
              </div>
            </div>

            <div class="card-body p-4 mt-5 tab-content" id="myTabContent">
              <div
                class="tab-pane fade show active"
                id="home"
                role="tabpanel"
                aria-labelledby="home-tab"
              >
                <div class="card card_8 d-block">
                  <div class="d-flex align-items-center w_30 mt_n3 ms-5 me-auto">
                    <i class="fas fa-envelope d-block" aria-hidden="true"></i>
                    <span class="d-block w-100 text-uppercase ms-2">
                      Pending Requests
                    </span>
                  </div>

                  <div class="card-body">
                    <div className="formisform">
                      <>
                        <div className="row ">
                          <div className="text-end">
                            {data.length > 0 && (
                              <>
                                <Button
                                  onClick={() => {
                                    // markAttendacnmodal();
                                    if (selectedFlatRows.length == 0) {
                                      // toast.error(
                                      //   "Please select Any Emmployee",
                                      //   {
                                      //     theme: "colored",
                                      //   }
                                      // );
                                      Swal.fire({
                                        icon: "error",
                                        title: "Oops...",
                                        text: "Please select Any Emmployee",
                                        // footer: '<a href="">Why do I have this issue?</a>'
                                      });
                                    } else {
                                      //   deletUser();
                                      approvalModal();
                                      setstateofButtons({
                                        ...stateofButtons,
                                        approval: true,
                                      });
                                    }
                                  }}
                                  endIcon={<CheckCircleIcon />}
                                  variant="contained"
                                  style={{ background: "#2EA822" }}
                                >
                                  Approve
                                </Button>
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                {/* )} */}
                                {/* {selectedFlatRows.length > 0 && ( */}
                                <Button
                                  onClick={() => {
                                    if (selectedFlatRows.length == 0) {
                                      // toast.error(
                                      //   "Please select Any Emmployee",
                                      //   {
                                      //     theme: "colored",
                                      //   }
                                      // );
                                      Swal.fire({
                                        icon: "error",
                                        title: "Oops...",
                                        text: "Please select Any Emmployee",
                                        // footer: '<a href="">Why do I have this issue?</a>'
                                      });
                                    } else {
                                      //   deletUser();
                                      rejecytionModal();
                                      setstateofButtons({
                                        ...stateofButtons,
                                        reject: true,
                                      });
                                    }
                                  }}
                                  endIcon={<ThumbDownAltIcon />}
                                  variant="contained"
                                  style={{ background: "#F70021" }}
                                >
                                  Reject
                                </Button>
                              </>
                            )}
                          </div>
                        </div>
                      </>

                      <div className="card mb-3 mt-4">
                        {data.length > 0 ? (
                          <>
                            <hr class="hr_Content" />
                            <div
                              class="d-flex align-items-center w_30 mt_n1 ms-5 me-auto"
                              id="commentDiv"
                            >
                              <i
                                class="fas fa-envelope d-block"
                                aria-hidden="true"
                              ></i>
                              <span class="d-block w-100 text-uppercase ms-2">
                                Pending Approvals
                              </span>
                            </div>
                            <div className="card-body p-4 ">
                              <div className="d-flex justify-content-between my-3">
                                {/* {searchIcon == true && ( */}
                                <select
                                  value={pageSize}
                                  className="dropdown"
                                  onChange={(e) => {
                                    setPageSize(Number(e.target.value));
                                  }}
                                >
                                  {[10, 25, 50].map((value, i) => {
                                    return (
                                      <option
                                        aria-labelledby="dropdownMenuButton1"
                                        value={value}
                                        key={value}
                                      >
                                        {" "}
                                        Show {value}
                                      </option>
                                    );
                                  })}
                                </select>
                                {/* )} */}

                                {/* <div>
                                    {allColumns.map((column) => {
                                      return (
                                        <div key={column.id}>
                                          <label>
                                            <input
                                              type="checkbox"
                                              {...column.getToggleHiddenProps()}
                                            />
                                            {column.Header}
                                          </label>
                                        </div>
                                      );
                                    })}
                                  </div> */}
                                {/* {searchIcon == true && ( */}
                                <TextField
                                  className="ms-4 "
                                  sx={{
                                    borderRadius: "4px",
                                  }}
                                  type="text"
                                  label="Search"
                                  name="Search"
                                  variant="outlined"
                                  // value={number}
                                  size="small"
                                  value={globalSearchValue || ""}
                                  onChange={(e) => {
                                    onChange(e.target.value);
                                    setGlobalSearchValue(e.target.value);
                                  }}
                                />
                                {/* )} */}
                              </div>

                              <div
                                className="table-responsive tableClass"
                                // style={{
                                //   width: "min-content",
                                //   marginLeft: "auto",
                                //   marginRight: "auto",
                                // }}
                              >
                                <table
                                  {...getTableProps()}
                                  id="example"
                                  className="table table-striped table-bordered dataTable table-sm mt-3 table-responsive"
                                  // className=" table table-responsive table-striped table-bordered dataTable mt-3"
                                >
                                  <thead>
                                    {headerGroups.map((headerGroup) => (
                                      <tr
                                        {...headerGroup.getHeaderGroupProps()}
                                      >
                                        {headerGroup.headers.map((column) => (
                                          <th
                                            {...column.getHeaderProps(
                                              column.getSortByToggleProps()
                                            )}
                                            className="text-center width_2"
                                          >
                                            {column.render("Header")}
                                            <span>
                                              {column.isSorted
                                                ? column.isSortedDesc
                                                  ? "↑"
                                                  : "↓"
                                                : ""}
                                            </span>
                                          </th>
                                        ))}
                                      </tr>
                                    ))}
                                  </thead>
                                  <tbody {...getTableBodyProps()}>
                                    {page.map((row) => {
                                      prepareRow(row);
                                      return (
                                        <tr {...row.getRowProps()}>
                                          {row.cells.map((cell) => {
                                            return (
                                              <td
                                                {...cell.getCellProps()}
                                                className="text-center"
                                              >
                                                {cell.render("Cell")}
                                              </td>
                                            );
                                          })}
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </div>
                              <div className="d-flex justify-content-between align-items-center mt-3">
                                <div>
                                  <span>
                                    Page:
                                    <strong>
                                      &nbsp; {pageIndex + 1} of{" "}
                                      {pageOptions.length}
                                    </strong>
                                  </span>

                                  {/* <span>
                                    &nbsp; &nbsp; Go to Page :{""}
                                    <input
                                      className="ms-2"
                                      type="number"
                                      // defaultValue={1}
                                      value={pageIndex + 1}
                                      onChange={(e) => {
                                        const pageNumber = e.target.value
                                          ? Number(e.target.value) - 1
                                          : 0;
                                        gotoPage(pageNumber);
                                      }}
                                      style={{ width: "50px" }}
                                    />
                                  </span> */}
                                </div>

                                <div id="Nikhil">
                                  <button
                                    className="btn btn_primary m-0 ms-2"
                                    type="button"
                                    style={{
                                      background: "#4C4234",
                                    }}
                                    disabled={!canPreviousPage}
                                    onClick={() => {
                                      previousPage();
                                    }}
                                  >
                                    Prev
                                  </button>

                                  <button
                                    className="btn btn_primary m-0 ms-2"
                                    type="button"
                                    style={{
                                      background: "#F67503",
                                    }}
                                    disabled={!canNextPage}
                                    onClick={() => {
                                      nextPage();
                                    }}
                                  >
                                    Next
                                  </button>
                                </div>
                              </div>
                            </div>
                          </>
                        ) : data?.length == 0 && open ? null : (
                          <div className="card-body">
                            <div>
                              <h5 style={{ textAlign: "center" }}>
                                {response}
                              </h5>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* <div class="text-end my-4">
                          <Button
                            type="submit"
                            //   disabled={buttonDisable}
                            variant="contained"
                            sx={{ background: "#F67503" }}
                            endIcon={<SendIcon />}
  
                            // onClick={() => {
                            //   // setOpen(true);
                            //   markModal();
                            // }}
                          >
                            Submit
                          </Button>
                        </div> */}
                    {/* {kunuVeer == true ? (
                          // <div class="container-fluid mt-3">
                          <div class="card d-block" id="new_store_entry">
                            <div class="card-header p-3 position-relative border-0 bg-white">
                              <DashboradTable
                                data111={datee}
                                id={employeesValue?.id}
                                userGrop={employeesValue?.userGroups}
                              />
                            </div>
                          </div>
                        ) : // </div>
                        null} */}
                  </div>
                </div>
              </div>

              {/* </div> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
